import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/masscort/masscort_new.png';
import {
  HiOutlineMenu,
  HiOutlineX,
  HiHome,
  HiUser,
  HiViewGrid,
  HiMail,
  HiCurrencyRupee,
  HiOutlineChip ,
  HiOutlineChatAlt,
  HiOutlineDesktopComputer
} from 'react-icons/hi';
import { BiChevronDown } from 'react-icons/bi';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showProductsDropdown, setShowProductsDropdown] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const dropdownTimeoutRef = useRef(null);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    if (!menuOpen) {
      setMobileDropdownOpen(false);
    }
  }, [menuOpen]);

  return (
    <nav className="bg-white shadow-lg py-3 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between">
        <Link to="/">
          <div className="flex items-center space-x-3">
            <img src={logo} alt="Logo" className="w-16 h-16 object-contain" />
            <span className="text-2xl font-bold text-blue-600">
              MyMarketing<span className="text-green-500">Buddy</span>
            </span>
          </div>
        </Link>

        <div className="hidden md:flex items-center space-x-6 text-gray-700 text-base font-medium">
          <Link to="/" className={`flex items-center gap-2 hover:text-blue-600 transition ${isActive('/') ? 'text-blue-600 font-semibold' : ''}`}>
            <HiHome /> Home
          </Link>
          <Link to="/about" className={`flex items-center gap-2 hover:text-blue-600 transition ${isActive('/about') ? 'text-blue-600 font-semibold' : ''}`}>
            <HiUser /> About Us
          </Link>

          <div
            className="relative"
            onMouseEnter={() => {
              clearTimeout(dropdownTimeoutRef.current);
              setShowProductsDropdown(true);
            }}
            onMouseLeave={() => {
              dropdownTimeoutRef.current = setTimeout(() => setShowProductsDropdown(false), 200);
            }}
          >
            <div className={`flex items-center gap-2 cursor-pointer hover:text-blue-600 transition ${(location.pathname.startsWith('/zappy') || location.pathname.startsWith('/quickbot') || isActive('/products')) ? 'text-blue-600 font-semibold' : ''}`}>
              <HiViewGrid /> Our Products <BiChevronDown />
            </div>
            {showProductsDropdown && (
              <div className="absolute top-full mt-2 bg-white shadow-lg rounded-lg py-2 w-48 z-40">
                <Link to="/zappy" className={`px-4 flex items-center gap-2 py-2 hover:bg-blue-50 text-sm ${isActive('/zappy') ? 'text-blue-600 font-semibold' : 'text-gray-700'}`}><HiOutlineChatAlt /> Zappy</Link>
                <Link to="/zapblast" className={`px-4 flex items-center gap-2 py-2 hover:bg-blue-50 text-sm ${isActive('/zapblast') ? 'text-blue-600 font-semibold' : 'text-gray-700'}`}><HiOutlineDesktopComputer  /> ZapBlast</Link>
                <Link to="/quickbot" className={`px-4 flex items-center gap-2 py-2 hover:bg-blue-50 text-sm ${isActive('/quickbot') ? 'text-blue-600 font-semibold' : 'text-gray-700'}`}><HiOutlineChip  /> QuickBot</Link>
              </div>
            )}
          </div>

          <Link to="/pricing" className={`flex items-center gap-2 hover:text-blue-600 transition ${isActive('/pricing') ? 'text-blue-600 font-semibold' : ''}`}>
            <HiCurrencyRupee /> Pricing
          </Link>
          <Link to="/contact" className={`flex items-center gap-2 hover:text-blue-600 transition ${isActive('/contact') ? 'text-blue-600 font-semibold' : ''}`}>
            <HiMail /> Contact
          </Link>
        </div>

        <div className="md:hidden">
          <button onClick={() => setMenuOpen(!menuOpen)} className="text-gray-700 text-2xl focus:outline-none">
            {menuOpen ? <HiOutlineX /> : <HiOutlineMenu />}
          </button>
        </div>
      </div>

      <div className={`fixed top-0 right-0 h-full w-64 bg-white shadow-2xl transform transition-transform duration-300 ease-in-out z-40 md:hidden ${menuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex flex-col p-6 space-y-6 text-gray-700 text-base font-medium">
          <button onClick={() => setMenuOpen(false)} className="self-end text-gray-600 text-2xl">
            <HiOutlineX />
          </button>

          <Link to="/" onClick={() => setMenuOpen(false)} className={`flex items-center gap-3 py-2 hover:text-blue-600 transition ${isActive('/') ? 'text-blue-600 font-semibold' : ''}`}>
            <HiHome /> Home
          </Link>
          <Link to="/about" onClick={() => setMenuOpen(false)} className={`flex items-center gap-3 py-2 hover:text-blue-600 transition ${isActive('/about') ? 'text-blue-600 font-semibold' : ''}`}>
            <HiUser /> About Us
          </Link>

          <div>
            <div
              onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
              className={`flex items-center gap-3 py-2 cursor-pointer hover:text-blue-600 transition ${(location.pathname.startsWith('/zappy') || location.pathname.startsWith('/quickbot') || isActive('/products')) ? 'text-blue-600 font-semibold' : ''}`}
            >
              <HiViewGrid /> Our Products <BiChevronDown />
            </div>
            {mobileDropdownOpen && (
              <div className="ml-6 mt-2 flex flex-col space-y-2 text-sm">
                <Link to="/zappy" onClick={() => setMenuOpen(false)} className={`flex items-center gap-2 py-2 ${isActive('/zappy') ? 'text-blue-600 font-semibold' : ''}`}><HiOutlineChatAlt /> Zappy</Link>
                <Link to="/zapblast" onClick={() => setMenuOpen(false)} className={`flex items-center gap-2 py-2 ${isActive('/zapblast') ? 'text-blue-600 font-semibold' : ''}`}><HiOutlineDesktopComputer /> ZapBlast</Link>
                <Link to="/quickbot" onClick={() => setMenuOpen(false)} className={`flex items-center gap-2 py-2 ${isActive('/quickbot') ? 'text-blue-600 font-semibold' : ''}`}><HiOutlineChip  /> QuickBot</Link>
              </div>
            )}
          </div>

          <Link to="/pricing" onClick={() => setMenuOpen(false)} className={`flex items-center gap-3 py-2 hover:text-blue-600 transition ${isActive('/pricing') ? 'text-blue-600 font-semibold' : ''}`}>
            <HiCurrencyRupee /> Pricing
          </Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)} className={`flex items-center gap-3 py-2 hover:text-blue-600 transition ${isActive('/contact') ? 'text-blue-600 font-semibold' : ''}`}>
            <HiMail /> Contact
          </Link>
        </div>
      </div>

      {menuOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 z-30 md:hidden" onClick={() => setMenuOpen(false)} />
      )}
    </nav>
  );
};

export default Navbar;
